import {LadingErrorStatus} from "@/enums/status/ladingerror";
import {LadingStatus} from "@/enums/status";

export class LadingErrorParams {
    page? = 1;
    limit? = 20;
    search?: string;
    ladingCode?: string;
    billLadingStatus?: LadingStatus;
    status?: number = LadingErrorStatus.ChoXuLy;
    fromDate?: number;
    toDate?: number;
    employeeCreatedRowGuid?: string;
    customerRowGuid?: string;
    employeeRowGuid?: string;
}
